import {GROUP_TYPE, GROUP_SECTION_WIDTH, drawBorderLines, drawBackground} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import Util from '../../../../forecast-app/shared/util/util';
import {drawExpansionImageIcon} from '../../canvas-timeline/canvas_timeline_icon_util';

class PersonGroupingGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PEOPLE_SCHEDULING_PERSON_GROUP, data);
		this.renderRowLines = true;
		this.hideIfAllChildrenAreFiltered = true;
		this.includeInRowHover = false;
	}

	draw(canvasContext, x, y, collapsableSectionHeight) {
		const width = GROUP_SECTION_WIDTH();
		const {height, expanded} = this;
		super.draw(x, y, width, height, this, collapsableSectionHeight);
		drawBackground(canvasContext, x, y, width, height, true);

		canvasContext.fillStyle = '#535353';
		canvasContext.font = '700 12px ' + Util.getFontFamily();
		canvasContext.fillText(this.data.name, x + 40, y + 28);
		drawBorderLines(canvasContext, 0, y, width, height, true);

		drawExpansionImageIcon(canvasContext, x, y, width, height, {
			expanded,
			align: 'left',
		});
	}
}

export default PersonGroupingGroup;
